import ModeEditIcon from "@mui/icons-material/Edit";
import MenuItem from "@mui/material/MenuItem";
import { FormikProps } from "formik";
import { MRT_Row } from "material-react-table";
import { useRef, useState } from "react";

import EditResourceCatalogueForm from "@/features/cost/resourceCatalogue/components/editResource/EditResourceForm";
import { ResourcesModel } from "@/features/cost/resourceCatalogue/types/resourcesModel";
import { RDialog } from "@/shared/components/forms";

type EditResourceCatalogueButtonProps = {
  row: MRT_Row<ResourcesModel>;
  onCatalogueAndCostRefetch: () => void;
};

export default function EditResourceCatalogueButton({
  row,
  onCatalogueAndCostRefetch,
}: EditResourceCatalogueButtonProps) {
  const [isModalOpen, setModalOpen] = useState(false);
  const editFormikRef = useRef<FormikProps<ResourcesModel>>(null);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleSubmitForm = () => {
    if (isModalOpen && editFormikRef.current) {
      void editFormikRef.current.submitForm();
      setModalOpen(false);
    }
  };

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <MenuItem
        key="edit"
        onClick={handleOpen}
        sx={{
          fontSize: "15px",
        }}>
        <ModeEditIcon fontSize="small" sx={{ marginRight: "5px" }} />
      </MenuItem>
      <RDialog
        isOpen={isModalOpen}
        title="Edit Resource Catalogue"
        confirmButtonCallback={handleSubmitForm}
        cancelButtonCallback={handleClose}
        confirmButtonText="Confirm"
        confirmButtonType="primary"
        confirmButtonDisabled={!isFormValid}
        size="medium">
        <EditResourceCatalogueForm
          row={row.original}
          onClose={handleClose}
          onCatalogueAndCostRefetch={onCatalogueAndCostRefetch}
          innerRef={editFormikRef}
          setIsFormValid={setIsFormValid}
        />
      </RDialog>
    </>
  );
}
